// extracted by mini-css-extract-plugin
module.exports = {"container":"heatConsumptionsGraph_container__35vy-"};